import { render } from "./AcceptanceBanner.vue?vue&type=template&id=97531de4&scoped=true"
const script = {}

import "./AcceptanceBanner.vue?vue&type=style&index=0&id=97531de4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mfeys\\Desktop\\HAv2\\actions\\19612-frontline\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97531de4"]])

export default __exports__